<template>
  <div>
    <CourseThumbBox
      :course="course"
    />

    <CourseProgressBar
      :percent="course.attended_percent"
    />
  </div>
</template>

<script>
  import CourseThumbBox from '@/components/course/CourseThumbBox'
  import CourseProgressBar from '@/components/course/CourseProgressBar'

  export default {
    components: {
      CourseThumbBox,
      CourseProgressBar
    },

    props: {
      course: { type: Object, required: true }
    }
  }
</script>
